import {UntypedFormControl} from '@angular/forms';

export function validateVerticalRange(control: UntypedFormControl) {
    if (control.value > 90 || control.value < -90){
        return { validateVerticalRange: true };
    }
    return null;
}
